import { FC } from "react";

import Container from "@/components/base/container";
import { CustomerSuccessStoryI } from "@/interfaces/strapi/collection-types";
import { ResponsiveSliderGrid } from "@/components/base/responsive-slider-grid";
import { CustomerSuccessStoryCard } from "@/components/base/cms/customer-success-story-card";
import { BackgroundShape } from "shared/ui/background-shape";
import { BACKGROUND_SHAPES } from "shared/ui/background-shape/constants";

interface OtherCustomerSuccessStoriesSectionPropsI {
  className?: string;
  stories?: CustomerSuccessStoryI[];
}

export const OtherCustomerSuccessStoriesSection: FC<
  OtherCustomerSuccessStoriesSectionPropsI
> = ({ className, stories }) => {
  if (!stories || stories.length === 0) {
    return null;
  }

  return (
    <Container className={className}>
      <div className="relative flex flex-col justify-center">
        <h5 className="text-center typography-header-5-semibold">
          Explore other success stories
        </h5>

        <ResponsiveSliderGrid
          className="mt-20 flex justify-center gap-4"
          items={stories}
          renderItem={(post) => (
            <CustomerSuccessStoryCard className="w-[400px]" {...post} />
          )}
        />

        <BackgroundShape
          className="-right-20 top-[360px] w-[520px] lg:left-1/2 lg:-translate-x-1/2"
          shape={BACKGROUND_SHAPES.FIGURE_6}
        />
      </div>
    </Container>
  );
};
